import { render } from "./AltriPagamenti.vue?vue&type=template&id=31acef5c"
import script from "./AltriPagamenti.vue?vue&type=script&lang=js"
export * from "./AltriPagamenti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__